/* eslint-disable array-callback-return */
/* eslint-disable no-loop-func */
/* eslint-disable no-plusplus */
import moment from 'moment';
import medidas from '@Consts/medidas';
import unidades from '@Consts/unidades';
import { conselhos, ufs } from '@Consts/conselhos';
import { EventBus } from '@EventBus';
import store from '../store';
import router from './router';

const dias_semana = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

function normalizarDataDDMMYYYY(data) {
  if (!data) return null;
  if (moment(data, 'DD/MM/YYYY', true).isValid())
    return data;

  if (/^\d{8}$/.test(data)) {
    const day = data.slice(0, 2);
    const month = data.slice(2, 4);
    const year = data.slice(4, 8);
    const formattedDate = `${day}/${month}/${year}`;
    if (moment(formattedDate, 'DD/MM/YYYY', true).isValid())
      return formattedDate;
  }
  if (moment(data, 'YYYY-MM-DD', true).isValid())
    return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY');


  return null;
}

function rgbToHtml(r, g, b) {
  const rgb = b | (g << 8) | (r << 16);
  return `#${(0x1000000 + rgb).toString(16).slice(1)}`;
}

function hsvToHtml(h, s, v) {
  let r, g, b;
  if (arguments.length === 1) {
    s = h.s; v = h.v; h = h.h;
  }
  const i = Math.floor(h * 6);
  const f = (h * 6) - i;
  const p = v * (1 - s);
  const q = v * (1 - (f * s));
  const t = v * (1 - ((1 - f) * s));
  switch (i % 6) {
    case 0: r = v; g = t; b = p; break;
    case 1: r = q; g = v; b = p; break;
    case 2: r = p; g = v; b = t; break;
    case 3: r = p; g = q; b = v; break;
    case 4: r = t; g = p; b = v; break;
    case 5: r = v; g = p; b = q; break;
    default: break;
  }
  return rgbToHtml(Math.round(r * 255), Math.round(g * 255), Math.round(b * 255));
}

function onlyNumber(str) {
  if (!str) return str;
  str = String(str);
  return str && str.replace(/\D/g, '');
}
function precoTotalCompraFunction(compra) {
  return compra.items.reduce((soma, produto) => soma + (produto.preco * produto.quantidade), 0);
}

const formatarDuasCasas = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
const formatarTresCasas = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 3,
  maximumFractionDigits: 3
});
const formatarInteiro = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
const maskDinheiroFunc = valor => ((valor || 0) / 100)
  .toFixed(2)
  .replace('.', ',')
  .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
const unmaskMoneyFunc = value => {
  try {
    if (typeof value === 'string')
      value = parseFloat(onlyNumber(value));
    return value;
  } catch (e) {
    return 0;
  }
};
const handleInputDataFrontFunction = value => {
  if (!value) return value;
  let v = value.replace(/\D/g, '').slice(0, 8);
  if (v.length >= 5)
    return `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}`;
  if (v.length >= 3)
    return `${v.slice(0, 2)}/${v.slice(2)}`;

  return v;
};

const fazerLogout = async () => {
  new Promise(async resolve => {
    await store.dispatch('CLEAR_STATE');
    localStorage.clear();
    EventBus.$off();
    resolve(true);
  });
};

export default {
  /*
  normalize('NFD') separa acentos das letras
  replace(/[\u0300-\u036f]/g, '') remove acentos da string [^a-zA-Z -]
  */

  normalizeString: (str = '') => str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase(),

  clearQuery: text => (text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(),

  Logout: async () => {
    await fazerLogout();
  },

  getSubpermissoesPersonalizadasPagina: (child_names, child_menus) => {
    const configuracoes = store.getters.contexto.configuracoes || {};
    const subpermissoes = [];
    if (!configuracoes.permissao || configuracoes.permissao !== 'personalizada') {
      return subpermissoes;
    }

    let menuAtivo = null;
    let submenuAtivo = null;
    let novoSubpermissions = null;
    child_names.forEach((child, i) => {
      const child_name = child.toLowerCase();
      const child_menu = child_menus.length ? child_menus[i].toLowerCase() : null;

      menuAtivo = (configuracoes.permissao_usuario || []).find(menu =>
        menu.ativo && menu.id.trim().toLowerCase() === (child_menu || child_name)
      );

      if (menuAtivo) {
        if ((child_menu && menuAtivo.id.trim().toLowerCase() === child_menu) || !child_menu) {
          submenuAtivo = (menuAtivo.submenus || []).find(submenu =>
            submenu.ativo && submenu.id.trim().toLowerCase() === child_name
          );

          if ((submenuAtivo || {}).subpermissions) {
            novoSubpermissions = Object.fromEntries(
              Object.entries(submenuAtivo.subpermissions).map(([key, value]) => {
                return [key, Object.keys(value).filter(subKey => value[subKey].ativo)];
              })
            );

            subpermissoes.push({
              nome: child_name,
              menu: child_menu,
              subpermissoes: novoSubpermissions
            });
          }
        }
      }
    });

    return subpermissoes;
  },

  hasActivePermissionUser: (child_names, bloquear_acesso = false, child_menus = [], return_false = false) => {
    const configuracoes = store.getters.contexto.configuracoes || {};

    if (!configuracoes.permissao || configuracoes.permissao !== 'personalizada') {
      if (return_false) {
        return false;
      }
      return true;
    }

    let acessoPermitido = false;

    child_names.forEach((child, i) => {
      if (!acessoPermitido) {
          const child_name = child.toLowerCase();
          const child_menu = child_menus.length ? child_menus[i].toLowerCase() : null;

          let menuAtivo = (configuracoes.permissao_usuario || []).some(menu =>
              menu.ativo && menu.id.trim().toLowerCase() === (child_menu || child_name)
          );

          let submenuAtivo = false;
          (configuracoes.permissao_usuario || []).forEach(menu => {
              if (!submenuAtivo) {
                if ((child_menu && menu.id.trim().toLowerCase() === child_menu) || !child_menu) {
                  submenuAtivo = (menu.submenus || []).some(submenu =>
                      submenu.ativo && submenu.id.trim().toLowerCase() === child_name
                  )
                }
              }
            }
          );

          if ((!child_menu && (menuAtivo || submenuAtivo)) || (child_menu && menuAtivo && submenuAtivo)) {
              acessoPermitido = true;
              return;
          }
        }
    });

    if (acessoPermitido) {
        return true;
    }

    if (bloquear_acesso) {
        store.dispatch('SHOW_SNACKBAR', { color: 'error', message: 'Você não tem permissão para acessar esse recurso' });
        fazerLogout();
        router.push({ name: 'Login', params: { stop: true } });
    }
    return false;
},

  hasAnyPermissions: permissions => (store.getters.contexto.configuracoes || {}).permissao && permissions.some(permission => permission === store.getters.contexto.configuracoes.permissao),

  hasUserPermissions: name_permissions => {
    if ((store.getters.contexto.configuracoes || {}).permissao_usuario)
      return store.getters.contexto.configuracoes.permissao_usuario.some(permission => permission.id === name_permissions && permission.ativo);
    return true;
  },

  hasPacientePermissions: name_permissions => {
    if ((store.getters.contexto.configuracoes || {}).permissoes_paciente)
      return store.getters.contexto.configuracoes.permissoes_paciente.some(permission => permission.id === name_permissions && permission.ativo);
    return true;
  },

  hasAdditional: module => {
    const adicionais = store.getters.contexto.instituicao.configuracoes.adicionais;
    if (!adicionais) return false;
    return adicionais.includes(module);
  },

  hasSubRoles: (rota = 'comercial', subRota) => {
    const configuracoes = store.getters.contexto.configuracoes || {};

    if (configuracoes.permissao && configuracoes.permissao.toLowerCase() === rota.toLowerCase()) {
      const hasPermission = (configuracoes.permissao_usuario || []).some(permission => permission.id.toLowerCase() === rota.toLowerCase()
          && (permission.submenus || []).some(submenu => submenu.id === String(subRota).trim() && Boolean(submenu.ativo)));
      return hasPermission;
    }

    return true;
  },

  hasType: module => {
    const tipo = store.getters.contexto.tipo;

    return module.includes(tipo);
  },

  hasTypePersonalizado: (module, type) => {
    return module.includes(type);
  },

  onlyNumber: str => {
    if (!str) return str;
    str = String(str);
    return str && str.replace(/\D/g, '');
  },

  onlyNumberBoleto: str => {
    if (!str) return str;
    str = String(str);
    let valor = str && str.replace(/\D/g, '');
    if (typeof (valor) === 'string')
      valor = Number(valor);
    valor /= 100;
    valor = valor.toFixed(2);
    // if (valor.substr(-2) === '00')
    // valor = valor.slice(0, -3);
    return valor.replace('.', ',');
  },

  uuid: () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  }),

  /* transformar um array de URL de imagem em um array de base64 */
  async array_imagens_base64(array) {
    const array_img = [];
    array.map(async elem => {
      const imagem = await this.getBase64(elem);
      array_img.push(imagem);
    });
    await new Promise(resolve => setTimeout(resolve, 2000));
    return array_img;
  },

  /* transformar uma URL de imagem em base64 */
  getBase64(targetUrl) {
    return new Promise(resolve => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      const proxyUrl = 'https://medyes-cors-anywhere.onrender.com/';
      xhr.open('GET', proxyUrl + targetUrl);
      xhr.responseType = 'blob';
      xhr.send();
    });
  },

  // brightness 0~1
  getColor: (seed, brightness = 0.99) => {
    let mW = seed;
    let mZ = seed;
    const mask = 0xffffffff;
    mZ = ((36969 * (mZ & 65535)) + (mZ >> 16)) & mask;
    mW = ((18000 * (mW & 65535)) + (mW >> 16)) & mask;
    const result = ((((mZ << 16) + mW) & mask) / 4294967296) + 0.5;
    const rand = (result + 0.618033988749895) % 1;
    return hsvToHtml(rand, 0.65, brightness);
  },

  getCEPNumbers: cep => cep.replace('-', '').replace('.', ''),

  getNome: nome_completo => {
    let nome = nome_completo.split(' ')[0];
    if (!nome)
      nome = ' ';
    return nome;
  },

  getSobrenome: nome_completo => {
    const nomes = nome_completo.split(' ');
    nomes.splice(0, 1);
    let sobrenome = nomes.join(' ');
    if (!sobrenome)
      sobrenome = ' ';
    return sobrenome;
  },

  calc_data: value => {
    if (value) {
      const json = JSON.parse(value);
      if (json.data_previsto && json.data_inicio) {
        const now = moment(json.data_previsto, 'DD/MM/YYYY'); // Outra data no passado
        const past = moment(json.data_inicio, 'DD/MM/YYYY'); // Data de hoje
        const duration = moment.duration(now.diff(past));
        return duration.asDays() + 1;
      }
      return 1;
    }
    return 1;
  },

  toPreciseNumber: value => {
    if (typeof value === 'string') {
      value = value.replace(/\./g, '').replace(/,/g, '.');

      if (value.includes('.'))
        return parseFloat(parseFloat(value).toFixed(3));
    }
    return Number(value);
  },

  converter_data: (data, ordem) => {
    // ordem == 1 //menor data
    // ordem == 2 //maior data
    let return_data = null;
    if (!data)
      if (ordem === 1)
        return_data = moment('01/01/1900').format('YYYY-MM-DD');
      else
        return_data = moment('31/12/9999').format('YYYY-MM-DD');
    else
      return_data = moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD');

    return return_data;
  },

  definirUnidadeMedida: unidade_medida => {
    let indice = null;
    if (unidade_medida) {
      indice = medidas.findIndex(elem => elem.value === unidade_medida);
      if (indice >= 0) {
        const unidade = medidas[indice].text.split(' ')[0];
        if (unidade.toLowerCase() === 'l')
          return 'L';
        return unidade.toLowerCase();
      }
      return '-';
    } return '-';
  },

  diferenca_data: (data_inicial, data_final) => {
    const now = moment(data_inicial, 'DD/MM/YYYY'); // Outra data no passado
    const past = moment(data_final, 'DD/MM/YYYY'); // Data de hoje
    const duration = moment.duration(now.diff(past));
    return duration.asDays();
  },

  items_status_atendimento: () => [
    { value: 1, text: 'Atenção domiciliar (Verde)', color: '#27ac39' },
    { value: 2, text: 'Assistência domiciliar (Azul)', color: '#3f51b5' },
    { value: 5, text: 'Gerenciamento crônico (Roxo)', color: '#9c27b0' },
    { value: 3, text: 'Internação domiciliar (Amarelo)', color: '#ffaf00' },
    { value: 4, text: 'Internação hospitalar (Vermelho)', color: '#ff3838' }
  ],

  setBorderAvatarColorPaciente: status_atendimento => {
    switch (status_atendimento) {
      case 1:
        return '#27ac39';
      case 2:
        return '#1B4381';
      case 3:
        return '#ffaf00';
      case 4:
        return '#ff3838';
      case 5:
        return '#9c27b0';
      default:
        return '#b8b8b8';
    }
  },

  items_modelo_contratacao: (lang_pt = false) => {
    const items = [
      { value: 1, text: 'Autônomo' },
      { value: 2, text: 'CLT' },
      { value: 3, text: 'CNPJ' },
      { value: 4, text: 'Cooperativa' },
      { value: 5, text: 'Estágio' },
      { value: 6, text: 'Jovem Aprendiz' },
      { value: 7, text: 'MEI' },
      { value: 8, text: 'Terceirizado' }
    ];

    if (lang_pt) {
      return items.map(item => ({
        valor: item.value,
        nome: item.text
      }));
    }
    return items;
  },

  // receber números
  formatarDecimal: valor => {
    if (valor) {
      if (typeof (valor) === 'string')
        valor = Number(valor);
      valor = valor.toFixed(2);
      if (valor.substr(-2) === '00')
        valor = valor.slice(0, -3);
      return valor.replace('.', ',');
    }
    return 0;
  },
  formatarDecimalQuantiade: (valor, tipo) => {
    const dados = store.getters.instituicao_atual.config_formato_quantidade;
    const validacao = Object.values(dados);
    const config = validacao && validacao.length ? dados : {
      servico: 1, medicamentos: 1, material: 2, equipamento: 1, dieta: 1
    };
    if (valor) {
      const novoValore = String(valor).replace(/[^0-9.]/g, '');
      if (config[tipo] === 1)
        return formatarInteiro.format(novoValore);
      if (config[tipo] === 2)
        return formatarDuasCasas.format(novoValore);
      if (config[tipo] === 3)
        return formatarTresCasas.format(novoValore);
    }
    return valor;
  },
  formatMoneyMaskWatch(value) {
    if (typeof value === 'string') {
      if (onlyNumber(value) === '')
        return '0';

      // eslint-disable-next-line radix
      value = parseInt(onlyNumber(value)) / 100;
    } else
      value /= 100;

    const money = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(value);
    return money;
  },
  formatarDinheiro(valor) {
    const opcoesDeFormato = {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    };
    const formatoMoedaBrasileira = new Intl.NumberFormat('pt-BR', opcoesDeFormato);
    return formatoMoedaBrasileira.format(valor);
  },
  pegarTipo(tipo_id) {
    let tipo = '';

    if (tipo_id === 1)
      tipo = 'servico';
    else if (tipo_id === 2)
      tipo = 'material';
    else if (tipo_id === 3)
      tipo = 'medicamento';
    else if (tipo_id === 4)
      tipo = 'equipamento';
    else if (tipo_id === 5)
      tipo = 'dieta';

    return tipo;
  },
  formatarDecimalQuantiadeRetorno: valor => {
    if (valor) {
      if (valor.substr(-3) === '000')
        valor = valor.slice(0, -3);
      return valor.replace(',', '.');
    }
    return 0;
  },
  formatDateToRequest: date => {
    if (!date || date.length !== 10) return null;
    if (date.includes('/'))
      if (date.includes(' '))
        return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD HH:mm');
      else return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    return moment(date).format('YYYY-MM-DD');
  },

  formatDateFromRequest: (date, formato = null) => {
    if (!date) return null;
    if (date.includes(' '))
      return moment(date, formato).format('DD/MM/YYYY HH:mm');
    return moment(date, formato).format('DD/MM/YYYY');
  },

  formatDateFromRequest2: (date, formato = null) => {
    if (!date) return null;
    return moment(date, formato).format('DD/MM/YYYY');
  },

  formatEvent: event => {
    if (!event) return {};
    const start = moment(event.start);
    const end = moment(event.end);
    return {
      data_entrada: start.format('DD/MM/YYYY'),
      data_saida: end.format('DD/MM/YYYY'),
      hora_entrada: start.format('HH:mm'),
      hora_saida: end.format('HH:mm')
    };
  },

  validarCpfCnpj: value => {
    if (!value) return false;
    value = value.replace(/\D/g, '');
    if (value.length === 11) {
      if (value === '00000000000') return false;
      let r;
      let s = 0;
      for (let i = 1; i <= 9; i += 1) s += parseInt(value[i - 1], 10) * (11 - i);
      r = (s * 10) % 11;
      if (r === 10 || r === 11) r = 0;
      if (r !== parseInt(value[9], 10)) return false;
      s = 0;
      for (let i = 1; i <= 10; i += 1) s += parseInt(value[i - 1], 10) * (12 - i);
      r = (s * 10) % 11;
      if (r === 10 || r === 11) r = 0;
      if (r !== parseInt(value[10], 10)) return false;
      return true;
    } if (value.length === 14) {
      if (value === '00000000000000'
        || value === '11111111111111'
        || value === '22222222222222'
        || value === '33333333333333'
        || value === '44444444444444'
        || value === '55555555555555'
        || value === '66666666666666'
        || value === '77777777777777'
        || value === '88888888888888'
        || value === '99999999999999')
        return false;

      let tamanho = value.length - 2;
      let numeros = value.substring(0, tamanho);
      const digitos = value.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i -= 1) {
        soma += numeros.charAt(tamanho - i) * pos;
        pos -= 1;
        if (pos < 2)
          pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

      if (String(resultado) !== digitos.charAt(0))
        return false;

      tamanho += 1;
      numeros = value.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i -= 1) {
        soma += numeros.charAt(tamanho - i) * pos;
        pos -= 1;
        if (pos < 2)
          pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (String(resultado) !== digitos.charAt(1))
        return false;

      return true;
    }
    return false;
  },

  validarUf: uf => {
    const buscarUF = ufs.find(u => u.text.startsWith(`${uf} -`));
    return (buscarUF || {}).value ? true : false;
  },

  formatConselho: value => {
    if (!value) return null;
    const conselho = (conselhos.find(c => c.value === value.conselho) || {}).text;
    const uf_conselho = (ufs.find(u => u.value === value.uf_conselho) || {}).text;
    if (!conselho && !uf_conselho) return '-';
    return `${conselho}${conselho && uf_conselho ? ` | ${uf_conselho}` : uf_conselho || ''}`;
  },

  maskEndereco: (endereco, pessoa = null) => {
    let cep;
    if ((pessoa || {}).enderecos_logradouro) {
      if (pessoa.enderecos_cep) cep = `- ${pessoa.enderecos_cep.substr(0, 5)}-${pessoa.enderecos_cep.substr(5, 3)}`;
      return `${pessoa.enderecos_logradouro ? `${pessoa.enderecos_logradouro}, ` : ''}${pessoa.enderecos_numero ? `${pessoa.enderecos_numero}` : 's/n'}${pessoa.enderecos_complemento ? ` ${pessoa.enderecos_complemento}` : ''}, ${pessoa.enderecos_cidade ? pessoa.enderecos_uf ? `${pessoa.enderecos_cidade}/` : pessoa.enderecos_cidade : ''}${pessoa.enderecos_uf || ''}${cep ? ' ' : ''}${cep || '-'}`;
    }
    if (!(endereco || {}).id) return null;
    if (endereco.cep) cep = `- ${endereco.cep.substr(0, 5)}-${endereco.cep.substr(5, 3)}`;
    return `${endereco.logradouro ? `${endereco.logradouro}, ` : ''}${endereco.numero ? `${endereco.numero}` : 's/n'}${endereco.complemento ? ` ${endereco.complemento}` : ''}, ${endereco.cidade ? endereco.uf ? `${endereco.cidade}/` : endereco.cidade : ''}${endereco.uf || ''}${cep ? ' ' : ''}${cep || '-'}`;
  },

  maskCep: cep => `${cep.substr(0, 5)}-${cep.substr(5, 3)}`,

  maskCpfCnpj: cpf_cnpj => {
    if (!cpf_cnpj || typeof cpf_cnpj !== 'string' || (cpf_cnpj.length !== 11 && cpf_cnpj.length !== 14)) return null;
    if (cpf_cnpj.length === 11)
      return `${cpf_cnpj.substr(0, 3)}.${cpf_cnpj.substr(3, 3)}.${cpf_cnpj.substr(6, 3)}-${cpf_cnpj.substr(9, 2)}`;
    return `${cpf_cnpj.substr(0, 2)}.${cpf_cnpj.substr(2, 3)}.${cpf_cnpj.substr(5, 3)}/${cpf_cnpj.substr(8, 4)}-${cpf_cnpj.substr(12, 2)}`;
  },

  maskCpfCnpjFormat: cpf_cnpj => {
    if (cpf_cnpj.length <= 11)
      return '###.###.###-##';
    return '##.###.###/####-##';
  },

  maskNumeroPis: numero_pis => {
    if (!numero_pis || typeof numero_pis !== 'string' || numero_pis.length !== 11) return null;
    return `${numero_pis.substr(0, 3)}.${numero_pis.substr(3, 4)}.${numero_pis.substr(7, 3)}-${numero_pis.substr(10, 1)}`;
  },

  maskTelefone: tel => {
    if (!tel) return '-';
    if (tel.length < 10 || tel.length > 12) return tel;

    const tam = tel.length % 2;
    const dd = tel.substr(0, 2);
    const pri = tel.substr(2, 4 + tam);
    const seg = tel.substr(6 + tam, 4);
    return `(${dd}) ${pri}-${seg}`;
  },

  maskData: (data, formato_saida = null, formato_entrada = null) => {
    if (!data || typeof data !== 'string') return '-';
    const _moment = moment(data, formato_entrada);
    if (!_moment.isValid) return '-';
    return _moment.format(formato_saida || 'DD/MM/YYYY');
  },

  maskMonth: (data, somente_mes = false) => {
    if (somente_mes) {
      data = String(data);
      data = data.padStart(2, '0');
    } else
      data = moment(data, 'YYYY-MM-DD HH:mm:ss').format('MM/YYYY');
    const mes = data.substr(0, 2);
    switch (mes) {
      case '01':
        return data.replace(mes, 'JANEIRO');
      case '02':
        return data.replace(mes, 'FEVEREIRO');
      case '03':
        return data.replace(mes, 'MARÇO');
      case '04':
        return data.replace(mes, 'ABRIL');
      case '05':
        return data.replace(mes, 'MAIO');
      case '06':
        return data.replace(mes, 'JUNHO');
      case '07':
        return data.replace(mes, 'JULHO');
      case '08':
        return data.replace(mes, 'AGOSTO');
      case '09':
        return data.replace(mes, 'SETEMBRO');
      case '10':
        return data.replace(mes, 'OUTUBRO');
      case '11':
        return data.replace(mes, 'NOVEMBRO');
      case '12':
        return data.replace(mes, 'DEZEMBRO');
      default:
        return 'Data inválida';
    }
  },
  unmaskMoney: value => unmaskMoneyFunc(value),
  maskDinheiro: valor => maskDinheiroFunc(valor),

  maskDinheiroGrafico: valor => ((valor || 0) / 100)
    .toFixed(2)
    .replace('.', '.')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1'),

  maskDinheiro2: valor => (valor || 0)
    .toFixed(2)
    .replace('.', ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'),

  validarFormatoDinheiro: valor => {
    const regex = /^R\$ \d{1,3}(?:\.\d{3})*(?:,\d{2})?$/;
    return regex.test(valor);
  },
  validarEmail: email => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  },
  valorDesconto: (valor_total, venda) => {
    let valor_com_desconto = 0;
    if (venda.desconto_em_real)
      valor_com_desconto = venda.desconto;
    else
      valor_com_desconto = (valor_total * venda.desconto) / 100;
    return valor_com_desconto;
  },

  valorAcrescimo: (valor_total, venda) => {
    let valor_com_desconto = 0;
    if (venda.acrescimo)
      if (venda.acrescimo.tipo_de_acrescimo !== null)
        if (venda.acrescimo.tipo_de_acrescimo)
          valor_com_desconto = venda.acrescimo.acrescimo_valor;
        else
          valor_com_desconto = 100 * ((Number(venda.acrescimo.acrescimo_valor / 10000)) * valor_total);

    return valor_com_desconto;
  },

  valorComissoes: (valor_total, comissoes) => {
    let valor = 0;
    comissoes.forEach(comissao => {
      if (comissao.tipo)
        valor += comissao.valor;
      else
        valor += ((Number(comissao.valor * valor_total)) / 100);
    });
    return valor;
  },

  precoComDesconto: (valor_total, venda) => {
    let valor_com_desconto = valor_total;
    if (venda.desconto_em_real)
      valor_com_desconto -= venda.desconto;
    else
      valor_com_desconto *= (100 - venda.desconto) / 100;
    if (venda.acrescimo)
      if (venda.acrescimo.tipo_de_acrescimo !== null)
        if (venda.acrescimo.tipo_de_acrescimo)
          valor_com_desconto += venda.acrescimo.acrescimo_valor;
        else
          valor_com_desconto += 100 * ((Number(venda.acrescimo.acrescimo_valor / 10000)) * valor_total);

    return valor_com_desconto;
  },

  tipoMedicamento: tipo => {
    switch (tipo) {
      case '02':
        return 'Antimicrobiano';
      case '03':
        return 'Sujeito a controle especial';
      default:
        return '-';
    }
  },

  // Exemplo: Valores em reais => transformar 1000 em R$ 10,00
  transformarPrecoItemUnidade: preco => {
    preco = Number(preco) / 100;
    preco = preco.toLocaleString('pt-br', { minimumFractionDigits: 2 });
    preco = `R$ ${preco}`;
    return preco;
  },

  transformarPrecoItemTotal: (preco, quantidade) => {
    preco = (Number(preco) / 100) * Number(quantidade);
    preco = preco.toLocaleString('pt-br', { minimumFractionDigits: 2 });
    preco = `R$ ${preco}`;
    return preco;
  },

  horario: hor => {
    let str;
    let unidade = '';
    if (!hor.quantidade_por_horario)
      hor.quantidade_por_horario = '';

    if ((unidades.find(un => un.valor === hor.unidade) || {}).nome)
      unidade = (unidades.find(un => un.valor === hor.unidade) || {}).nome;

    if (hor.horario === 'Antes do almoço' || hor.horario === 'Ao deitar' || hor.horario === 'Após o almoço')
      str = `${hor.quantidade_por_horario} ${unidade} ${hor.horario.toLowerCase()}`;
    else if (hor.horario.includes('Se necessário'))
      str = `${hor.quantidade_por_horario} ${unidade} ${hor.horario}`;
    else if (hor.horario === 'Jejum' || hor.horario === 'Manhã' || hor.horario === 'Noite' || hor.horario === 'Tarde')
      str = `${hor.quantidade_por_horario} ${unidade !== '' ? `${unidade} de` : ''} ${hor.horario.toLowerCase()}`;
    else
      str = `${hor.quantidade_por_horario} ${unidade !== '' ? `${unidade} às` : ''} ${hor.horario}`;
    return `${str[0].toUpperCase()}${str.slice(1)}`;
  },

  checarValidadeData(data) {
    // formato DD/MM/YYYY
    const regex = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
    if (!regex.test(data))
      return false;
    return true;
  },

  checarValidadeHorario(horario) {
    // formato HH:mm
    const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    if (!regex.test(horario))
      return false;
    return true;
  },

  dadosBancariosFormatado(pessoa) {
    if (pessoa && pessoa.dadosBancarios)
      return `${pessoa.dadosBancarios ? `${pessoa.dadosBancarios.key_pix ? ` - Pix: ${pessoa.dadosBancarios.key_pix}` : ''}` : ''}${pessoa.dadosBancarios && pessoa.dadosBancarios.banco ? ` - ${pessoa.dadosBancarios.banco}` : ''}${pessoa.dadosBancarios && pessoa.dadosBancarios.tipo_conta ? ` - ${pessoa.dadosBancarios.tipo_conta}` : ''}${pessoa.dadosBancarios && pessoa.dadosBancarios.agencia ? ` - Ag: ${pessoa.dadosBancarios.agencia}` : ''}${pessoa.dadosBancarios && pessoa.dadosBancarios.conta ? ` - Conta: ${pessoa.dadosBancarios.conta}${pessoa.dadosBancarios.digito_conta ? `-${pessoa.dadosBancarios.digito_conta}` : ''}` : ''}${pessoa.dadosBancarios && pessoa.dadosBancarios.operacao ? ` Op: ${pessoa.dadosBancarios.operacao}` : '-'}`;
    return '-';
  },

  formatarData(data) {
    if (!data) return data;
    // usar no watch da DATA
    // adicionar class="data"
    // formato DD/MM/YYYY
    const dataInputs = document.getElementsByClassName('data');
    const MAX_LENGTH = 10;
    // Remove todos os caracteres que não sejam números
    data = data.replace(/\D/g, '');

    // Insere as barras automaticamente enquanto escreve
    if (data.length > 2)
      data = data.replace(/(\d{2})(\d)/, '$1/$2');

    if (data.length > 5)
      data = data.replace(/(\d{2})(\d)/, '$1/$2');

    const isTextSelected = input => {
      if (typeof input.selectionStart === 'number' && typeof input.selectionEnd === 'number')
        return input.selectionStart !== input.selectionEnd;

      return false;
    };

    const limitarComprimento = event => {
      const dataInput = event.target;
      const maxLengthReached = dataInput.value.length >= MAX_LENGTH;

      if (maxLengthReached && !isTextSelected(dataInput) && event.keyCode !== 8 && event.keyCode !== 46)
        event.preventDefault();
    };

    for (let i = 0; i < dataInputs.length; i++) {
      const dataInput = dataInputs[i];
      dataInput.addEventListener('keydown', limitarComprimento);
    }

    return data;
  },

  getRangeDatas: (data_inicio, data_termino) => {
    // adiciona um dia após data_termino pois, a depender do horário, não está mostrando o último dia
    data_inicio = moment(data_inicio, 'YYYY-MM-DD HH:mm:ss');
    data_termino = moment(data_termino, 'YYYY-MM-DD HH:mm:ss').add(1, 'days');
    const diff = data_termino.diff(data_inicio, 'days');
    const range = [];
    for (let i = 0; i <= diff; i++)
      range.push(moment(data_inicio).add(i, 'days').format('YYYY-MM-DD'));

    return range;
  },

  getDatasPeriodo: (periodo, inicio_, data_final) => {
    let data_inicial = inicio_;

    if (!moment(data_inicial, 'YYYY-MM-DD', true).isValid() && !moment(data_inicial, 'DD/MM/YYYY', true).isValid()) {
      data_inicial = handleInputDataFrontFunction(data_inicial);

      if (!moment(data_inicial, 'DD/MM/YYYY', true).isValid())
        return { relatorio_dias: [], erro: `Data de início ${data_inicial} é inválida! Corrija-a e tente novamente.` };
    }

    const inicio = moment(data_inicial, 'DD/MM/YYYY', true).isValid()
      ? moment(data_inicial, 'DD/MM/YYYY')
      : moment(data_inicial, 'YYYY-MM-DD');
    const fim = moment(data_final, 'DD/MM/YYYY', true).isValid()
      ? moment(data_final, 'DD/MM/YYYY')
      : moment(data_final, 'YYYY-MM-DD');

    if (!inicio.isValid() || !fim.isValid())
      return { relatorio_dias: [], erro: 'Intervalo de datas inválido.' };


    const datasArray = [];

    const fillDatas = label => {
      const formattedDate = moment(label).format('DD/MM/YYYY');
      if (!datasArray.some(item => item.data === formattedDate))
        datasArray.push({ data: formattedDate, quantidade: 1 });
    };

    let sim = true;
    let intervalo_72h = 0;
    let intervalo_96h = 0;
    let intervalo_semanal = 0;
    let intervalo_quinzenal = 0;

    for (let i = 0; i < fim.diff(inicio, 'days') + 1; i++) {
      const dia = moment(inicio).add(i, 'days');
      const label = dia.format('YYYY-MM-DD');

      switch (periodo.periodo_info) {
        case 1:
          fillDatas(label);
          break;
        case 2:
          if (sim) fillDatas(label);
          sim = !sim;
          break;
        case 3:
          if (periodo.dias_da_semana.includes(dias_semana[dia.day()])) fillDatas(label);
          break;
        case 4:
          if (periodo.dias_do_mes.includes(dia.format('DD'))) fillDatas(label);
          break;
        case 6:
          if (intervalo_72h === 0) fillDatas(label);
          intervalo_72h = intervalo_72h !== 2 ? intervalo_72h + 1 : 0;
          break;
        case 7:
          if (intervalo_96h === 0) fillDatas(label);
          intervalo_96h = intervalo_96h !== 3 ? intervalo_96h + 1 : 0;
          break;
        case 8:
          if (intervalo_semanal === 0) fillDatas(label);
          intervalo_semanal = intervalo_semanal !== 6 ? intervalo_semanal + 1 : 0;
          break;
        case 9:
          if (intervalo_quinzenal === 0) fillDatas(label);
          intervalo_quinzenal = intervalo_quinzenal !== 14 ? intervalo_quinzenal + 1 : 0;
          break;
        default:
          break;
      }
    }

    return datasArray;
  },


  getHorario: hor => {
    const map_horarios = {
      'Se necessário (SOS)': -5,
      Jejum: -12,
      'Ao deitar': -13,
      '00:00': 0,
      '00:30': 3,
      Manhã: -14,
      'ANTES DO ALMOÇO': -15,
      'APÓS O ALMOÇO': -16,
      Tarde: -17,
      Noite: -18
    };
    let hora = Number(`${hor.slice(0, 2)}.${hor.slice(3, 5)}`);
    if (!hora) hora = map_horarios[hor];
    return hora;
  },

  getQuantidadePrevistaPrescricao: (prescricao, inicio, fim, produto_id = null) => {
    const formatDateToRequest = date => {
      if (!date || date.length !== 10)
        if (date && date.length === 8 && !date.includes('/')) {
          date = handleInputDataFrontFunction(date);
          if (!moment(date, 'DD/MM/YYYY', true).isValid())
            return null;

          return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        } else {
          return null;
        }

      if (date.includes('/'))
        if (date.includes(' '))
          return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD HH:mm');
        else return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
      return moment(date).format('YYYY-MM-DD');
    };
    inicio = formatDateToRequest(inicio);
    fim = formatDateToRequest(fim);

    let items = null;
    if (prescricao.itemsPrescricao)
      items = prescricao.itemsPrescricao;
    if (prescricao.prescricaoEnfer)
      items = prescricao.prescricaoEnfer;

    const posologias = {
      1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 9: []
    };

    if (produto_id)
      items = items.filter(i => i.produto_id === produto_id);

    items.forEach(item => {
      let posologia = null;
      if (item.posologia)
        posologia = item.posologia;
      if (item.horarios)
        posologia = item.horarios;

      if (item.procedimento)
        if (item.procedimento.produtos_prescricao) {
          item.procedimento.produtos = item.procedimento.produtos_prescricao;
          delete item.procedimento.produtos_prescricao;
        }


      if (posologia.se_necessario || posologia.necessary) {
        const indice_horarios = posologia.horarios.findIndex(hor => hor.horario.includes('Se necessário'));
        if (indice_horarios < 0)
          posologia.horarios.push({
            horario: 'Se necessário (SOS)',
            unidade: posologia.horarios.length ? posologia.horarios[0].unidade : '',
            quantidade_por_horario: 0,
            dosagem: ''
          });
      }


      if (!posologias[posologia.periodo_de_uso])
        posologias[posologia.periodo_de_uso] = [];
      const info = {};
      if (item.produto)
        info.produto = {
          id: item.produto.id, nome: item.produto.nome, dosagem: item.produto.dosagem, tipo_id: item.produto.tipo_id
        };
      else if (item.produto_id)
        info.produto = { id: item.produto_id };
      else if (item.procedimento)
        info.procedimento = {
          id: item.procedimento.id,
          identificacao: item.procedimento.identificacao,
          orientacao: item.procedimento.orientacao,
          produtos: item.procedimento.produtos && item.procedimento.produtos.length ? item.procedimento.produtos.map(produto => ({
            id: produto.id, nome: produto.nome, quantidade: produto.pivot.quantidade, unidade: produto.unidade
          })) : []
        };
      else if (item.procedimento_id)
        info.procedimento = { id: item.procedimento_id };

      posologias[posologia.periodo_de_uso].push({
        item: info, posologia, dosagem: item.dosagem || null, sim: true, intervalo_72h: 0, intervalo_96h: 0, intervalo_semanal: 0, intervalo_quinzenal: 0
      });
    });

    const fillDatas = (label, datas, item) => {
      if (!datas[label])
        datas[label] = {};

      item.posologia.horarios.forEach(horario => {
        if (!datas[label][horario.horario])
          datas[label][horario.horario] = [];
        datas[label][horario.horario].push({
          ...item.item,
          quantidade: horario.quantidade_por_horario,
          unidade: horario.unidade,
          administracao: item.posologia.administracao,
          obs: item.posologia.observacao,
          necessary: item.posologia.necessary,
          se_necessario: item.posologia.se_necessario,
          periodo_de_uso: item.posologia.periodo_de_uso,
          dias_da_semana: item.posologia.dias_da_semana,
          dias_do_mes: item.posologia.dias_do_mes,
          outro_periodo: item.posologia.outro_periodo,
          data_inicio: item.posologia.data_inicio || item.posologia.data_inicial,
          dosagem: item.dosagem
        });
      });
    };

    const datas = {};
    posologias[5].forEach(item => {
      if (inicio && (/^\d{4}-\d{2}-\d{2}$/.test(inicio))) {
        inicio = `${inicio} 00:00:00`;
      }

      const dia = dias_semana.indexOf(item.posologia.outro_periodo.dia);
      let data = moment(item.posologia.data_inicial ? normalizarDataDDMMYYYY(item.posologia.data_inicial) : inicio, item.posologia.data_inicial ? 'DD/MM/YYYY' : 'YYYY-MM-DD HH:mm:ss');
      if (item.posologia.outro_periodo.tipo === 'Primeiro(a)') {
        data = data.startOf('month');
        if (data.weekday() > dia)
          data.add(1, 'weeks');
        data = data.startOf('week').add(dia, 'days');
        if (data < moment(inicio)) {
          data = data.startOf('month').add(1, 'months');
          if (data.weekday() > dia)
            data.add(1, 'weeks');
          data = data.startOf('week').add(dia, 'days');
        }
      } else {
        data = data.endOf('month');
        if (data.weekday() < dia)
          data.subtract(1, 'weeks');
        data = data.startOf('week').add(dia, 'days');
        if (data < moment(inicio)) {
          data = data.add(1, 'months').endOf('month');
          if (data.weekday() < dia)
            data.subtract(1, 'weeks');
          data = data.startOf('week').add(dia, 'days');
        }
      }
      fillDatas(data.format('YYYY-MM-DD'), datas, item);
    });

    for (let i = 0; i < moment(fim).diff(moment(inicio), 'days') + 1; i += 1) {
      const dia = moment(inicio).add(i, 'days');
      const label = dia.format('YYYY-MM-DD');

      posologias[1].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY')))
          fillDatas(label, datas, item);
      });

      // eslint-disable-next-line no-loop-func
      posologias[2].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY'))) {
          if (item.sim)
            fillDatas(label, datas, item);
          item.sim = !item.sim;
        }
      });

      posologias[6].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY'))) {
          if (item.intervalo_72h === 0)
            fillDatas(label, datas, item);
          if (item.intervalo_72h !== 2) item.intervalo_72h += 1;
          else item.intervalo_72h = 0;
        }
      });

      // intervalo_96h
      posologias[7].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY'))) {
          if (item.intervalo_96h === 0)
            fillDatas(label, datas, item);
          if (item.intervalo_96h !== 3) item.intervalo_96h += 1;
          else item.intervalo_96h = 0;
        }
      });

      // intervalo_semanal
      posologias[8].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY'))) {
          if (item.intervalo_semanal === 0)
            fillDatas(label, datas, item);
          if (item.intervalo_semanal !== 6) item.intervalo_semanal += 1;
          else item.intervalo_semanal = 0;
        }
      });

      posologias[9].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY'))) {
          if (item.intervalo_quinzenal === 0)
            fillDatas(label, datas, item);
          if (item.intervalo_quinzenal !== 14) item.intervalo_quinzenal += 1;
          else item.intervalo_quinzenal = 0;
        }
      });

      posologias[3].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY')))
          if (item.posologia.dias_da_semana.indexOf(dias_semana[dia.weekday()]) >= 0)
            fillDatas(label, datas, item);
      });

      posologias[4].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY')))
          if (item.posologia.dias_do_mes.indexOf(dia.format('DD')) >= 0)
            fillDatas(label, datas, item);
      });
    }
    const relatorio_dias = {};

    const getHorario = hor => {
      const map_horarios = {
        'Se necessário (SOS)': -5,
        Jejum: -12,
        'Ao deitar': -13,
        '00:00': 0,
        '00:30': 3,
        Manhã: -14,
        'ANTES DO ALMOÇO': -15,
        'APÓS O ALMOÇO': -16,
        Tarde: -17,
        Noite: -18
      };
      let hora = Number(`${hor.slice(0, 2)}.${hor.slice(3, 5)}`);
      if (!hora) hora = map_horarios[hor];
      return hora;
    };

    Object.keys(datas).sort().forEach(data => {
      relatorio_dias[data] = {};
      Object.keys(datas[data])
        .sort((a, b) => (getHorario(a) > getHorario(b) ? 1 : -1))
        .forEach(horario => {
          relatorio_dias[data][horario] = datas[data][horario];
        });
    });

    const produtos_quantidade = [];
    let indice = -1;
    Object.keys(relatorio_dias).forEach(dia => {
      const horarios = relatorio_dias[dia];
      Object.values(horarios).forEach(horario => {
        if (horario.length)
          horario.forEach(hora => {
            indice = produtos_quantidade.findIndex(elem => elem.produto_id === hora.produto.id);
            if (indice < 0)
              produtos_quantidade.push({ produto_id: hora.produto.id, quantidade: hora.quantidade });
            else
              produtos_quantidade[indice].quantidade += hora.quantidade;
          });
      });
    });

    if (prescricao.produtos.length && produtos_quantidade.length) {
      if (produto_id)
        prescricao.produtos = prescricao.produtos.filter(i => i.produto_id === produto_id);

      prescricao.produtos.map(item => {
        indice = produtos_quantidade.findIndex(elem => elem.produto_id === item.produto_id);
        if (indice >= 0)
          item.posologia.quantidade_prevista = produtos_quantidade[indice].quantidade;
      });
    } else if (prescricao.procedimentos && prescricao.procedimentos.length && produtos_quantidade.length)
      prescricao.procedimentos.forEach(item => {
        indice = produtos_quantidade.findIndex(elem => elem.procedimento_id === item.procedimento_id);
        if (indice >= 0)
          item.horarios.quantidade_prevista = produtos_quantidade[indice].quantidade;
      });


    return prescricao.produtos ? prescricao.produtos : prescricao.procedimentos;
  },

  getDatasPrescricao: prescricao => {
    const getHorario = hor => {
      const map_horarios = {
        'Se necessário (SOS)': -5,
        Jejum: -12,
        'Ao deitar': -13,
        '00:00': 0,
        '00:30': 3,
        Manhã: -14,
        'ANTES DO ALMOÇO': -15,
        'APÓS O ALMOÇO': -16,
        Tarde: -17,
        Noite: -18
      };
      let hora = Number(`${hor.slice(0, 2)}.${hor.slice(3, 5)}`);
      if (!hora) hora = map_horarios[hor];
      return hora;
    };

    let inicio = prescricao.data_inicio;
    const fim = prescricao.data_termino;
    let items = null;
    if (prescricao.itemsPrescricao)
      items = prescricao.itemsPrescricao;
    if (prescricao.prescricaoEnfer)
      items = prescricao.prescricaoEnfer;
    const posologias = {
      1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 9: []
    };

    items.forEach(item => {
      let posologia = null;
      if (item.posologia)
        posologia = item.posologia;
      if (item.horarios)
        posologia = item.horarios;

      if (!posologias[posologia.periodo_de_uso])
        posologias[posologia.periodo_de_uso] = [];
      const info = {};
      if (item.produto_id)
        info.produto = { id: item.produto_id };
      else
      if (item.procedimento_id)
        info.procedimento = {
          id: item.procedimento_id
        };

      posologias[posologia.periodo_de_uso].push({ item: info, posologia, sim: true, intervalo_72h: 0, intervalo_96h: 0, intervalo_semanal: 0, intervalo_quinzenal: 0 });
    });

    const fillDatas = (label, datas, item) => {
      if (!datas[label])
        datas[label] = { produtos_id: [], procedimentos_id: [] };

      if (item.item.produto)
        datas[label].produtos_id.push(item.item.produto.id);
      if (item.item.procedimento)
        datas[label].procedimentos_id.push(item.item.procedimento.id);
    };

    const datas = {};
    posologias[5].forEach(item => {
      if (inicio && (/^\d{4}-\d{2}-\d{2}$/.test(inicio))) {
        inicio = `${inicio} 00:00:00`;
      }

      const dia = dias_semana.indexOf(item.posologia.outro_periodo.dia);
      let data = moment(item.posologia.data_inicial ? normalizarDataDDMMYYYY(item.posologia.data_inicial) : inicio, item.posologia.data_inicial ? 'DD/MM/YYYY' : 'YYYY-MM-DD HH:mm:ss');
      if (item.posologia.outro_periodo.tipo === 'Primeiro(a)') {
        data = data.startOf('month');
        if (data.weekday() > dia)
          data.add(1, 'weeks');
        data = data.startOf('week').add(dia, 'days');
        if (data < moment(inicio)) {
          data = data.startOf('month').add(1, 'months');
          if (data.weekday() > dia)
            data.add(1, 'weeks');
          data = data.startOf('week').add(dia, 'days');
        }
      } else {
        data = data.endOf('month');
        if (data.weekday() < dia)
          data.subtract(1, 'weeks');
        data = data.startOf('week').add(dia, 'days');
        if (data < moment(inicio)) {
          data = data.add(1, 'months').endOf('month');
          if (data.weekday() < dia)
            data.subtract(1, 'weeks');
          data = data.startOf('week').add(dia, 'days');
        }
      }

      fillDatas(data.format('YYYY-MM-DD'), datas, item);
    });

    for (let i = 0; i < moment(fim).diff(moment(inicio), 'days') + 1; i += 1) {
      const dia = moment(inicio).add(i, 'days');
      const label = dia.format('YYYY-MM-DD');

      posologias[1].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY')))
          fillDatas(label, datas, item);
      });

      // eslint-disable-next-line no-loop-func
      posologias[2].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY'))) {
          if (item.sim)
            fillDatas(label, datas, item);
          item.sim = !item.sim;
        }
      });

      posologias[6].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY'))) {
          if (item.intervalo_72h === 0)
            fillDatas(label, datas, item);
          if (item.intervalo_72h !== 2) item.intervalo_72h += 1;
          else item.intervalo_72h = 0;
        }
      });

      // intervalo_96h
      posologias[7].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY'))) {
          if (item.intervalo_96h === 0)
            fillDatas(label, datas, item);
          if (item.intervalo_96h !== 3) item.intervalo_96h += 1;
          else item.intervalo_96h = 0;
        }
      });

      // intervalo_semanal
      posologias[8].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY'))) {
          if (item.intervalo_semanal === 0)
            fillDatas(label, datas, item);
          if (item.intervalo_semanal !== 6) item.intervalo_semanal += 1;
          else item.intervalo_semanal = 0;
        }
      });

      posologias[9].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY'))) {
          if (item.intervalo_quinzenal === 0)
            fillDatas(label, datas, item);
          if (item.intervalo_quinzenal !== 14) item.intervalo_quinzenal += 1;
          else item.intervalo_quinzenal = 0;
        }
      });

      posologias[3].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY')))
          if (item.posologia.dias_da_semana.indexOf(dias_semana[dia.weekday()]) >= 0)
            fillDatas(label, datas, item);
      });

      posologias[4].forEach(item => {
        if (!item.posologia.data_inicio || !moment(dia, 'YYYY-MM-DD').isBefore(moment(normalizarDataDDMMYYYY(item.posologia.data_inicio), 'DD/MM/YYYY')))
          if (item.posologia.dias_do_mes.indexOf(dia.format('DD')) >= 0)
            fillDatas(label, datas, item);
      });
    }

    const relatorio_dias = {};

    Object.keys(datas).sort().forEach(data => {
      relatorio_dias[data] = {};
      Object.keys(datas[data])
        .sort((a, b) => {
          if (a === 'Jejum' || b === 'Ao deitar') return -1;
          if (b === 'Jejum' || a === 'Ao deitar') return 1;
          return getHorario(a) > getHorario(b) ? 1 : -1;
        })
        .forEach(horario => {
          relatorio_dias[data][horario] = datas[data][horario];
        });
    });
    return relatorio_dias;
  },
  getDateMonthName: data => {
    const date = new Date(data);

    const monthNames = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    const monthName = monthNames[date.getMonth()];
    return monthName;
  },
  debounce: (func, wait, immediate = false) => {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },
  calculateTotalsFolha: campos => {
    let totalCredito = 0;
    let totalDebito = 0;

    campos.filter(campo => campo.area_campo === 'descricao').forEach(campo => {
      if (campo.infos.descricao === 'credito' && campo.valor)
        totalCredito += unmaskMoneyFunc(campo.valor);

      if (campo.infos.descricao === 'debito' && campo.valor)
        totalDebito += unmaskMoneyFunc(campo.valor);
    });

    const valorLiquido = totalCredito - totalDebito;

    return {
      totalCredito: `R$ ${maskDinheiroFunc(totalCredito)}`,
      totalDebito: `R$ ${maskDinheiroFunc(totalDebito)}`,
      valorLiquido: `R$ ${maskDinheiroFunc(valorLiquido)}`
    };
  },
  calcularDebitoFolhaCompra: folha => {
    let debito_folha = 0;
    if (folha && folha.modelo_id === 1 && folha.campos && folha.campos.length)
      debito_folha = folha.campos.reduce((soma, campo) => {
        if (campo.area_campo === 'descricao' && campo.infos && campo.infos.descricao && campo.infos.descricao === 'debito')
          soma += Number(campo.valor.replace(/\D/g, ''));

        return soma;
      }, 0);


    return debito_folha;
  },
  preco_total_compra: compra => {
    return precoTotalCompraFunction(compra);
  },
  preco_com_desconto_compra: compra => {
    let preco = precoTotalCompraFunction(compra);
    if (compra.desconto.desconto_em_real !== null && compra.desconto.desconto_em_real !== undefined)
      if (compra.desconto.desconto_em_real)
        preco -= compra.desconto.desconto;
      else
        preco *= (100 - compra.desconto.desconto) / 100;
    if (compra.acrescimo)
      if (compra.acrescimo.acrescimo_valor !== null && compra.acrescimo.acrescimo_valor !== undefined)
        if (compra.acrescimo.tipo_de_acrescimo)
          preco += compra.acrescimo.acrescimo_valor;
        else {
          preco += 10000 * ((100 * Number(compra.acrescimo.acrescimo_valor)) / preco);
        }

    if (compra.desconto_folha)
      preco -= compra.desconto_folha;


    return preco;
  },
  handleInputDataFront: value => handleInputDataFrontFunction(value),
  normalizeDataDDMMYYYY: data => {
    return normalizarDataDDMMYYYY(data);
  },
  calcularPrecoPorFracao: (preco, divisor_fracao = 1, info_origem = true) => {
    const precoFloat = parseFloat(unmaskMoneyFunc(preco));
    const fracao = parseFloat(divisor_fracao || 1);
    let resultado = precoFloat * fracao;
    if (isNaN(resultado) || !isFinite(resultado))
      resultado = precoFloat;

    return info_origem ? Math.round(resultado) : `R$ ${maskDinheiroFunc(resultado.toFixed(3))}`;
  },
  async executeWithPool(funcoesRequest, qtdExecSimult, isPageActiveFn) {
    // Pode ser utilizada para controlar o máximo de requisições simultâneas em uma página
    let index = 0;

    async function worker() {
      while (index < funcoesRequest.length) {
        if (!isPageActiveFn()) { // Chama a função para pegar o valor atualizado
          console.log('Execução interrompida devido à mudança de rota.');
          return;
        }

        const currentIndex = index++;

        await funcoesRequest[currentIndex]();
      }
    }

    await Promise.all(Array.from({ length: qtdExecSimult }, () => worker()));
  },
};
